import { useDispatch } from "react-redux";
import { addToast, Toast } from "web/redux/ducks/toasts";

export function useToast(): UseToastResult {
    const dispatch = useDispatch();

    return function toast(props: Toast): void {
        dispatch(addToast(props));
    };
}

type UseToastResult = (props: Toast) => void;
